import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRocket, faArrowRight } from '@/fontawesome';

interface UpgradePromptProps {
  previewCount: number;
  featureName: string;
  className?: string;
}

export default function UpgradePrompt({ previewCount, featureName, className = '' }: UpgradePromptProps) {
  if (previewCount <= 0) {
    return null;
  }

  return (
    <div className={`bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl p-4 lg:p-6 text-white shadow-lg ${className}`}>
      <div className="flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <div className="p-3 bg-white/20 rounded-full hidden sm:block">
            <FontAwesomeIcon icon={faRocket} className="w-6 h-6" />
          </div>
          <div className="text-center md:text-left">
            <h3 className="text-lg lg:text-xl font-bold">
              Es gibt noch {previewCount} weitere {featureName}
            </h3>
            <p className="text-blue-100 text-sm">
              Schalte jetzt alle Tradingideen frei
            </p>
          </div>
        </div>
        <Link
          to="/pricing"
          className="flex items-center gap-2 px-5 py-2.5 lg:px-6 lg:py-3 bg-white text-blue-600 font-semibold rounded-lg hover:bg-blue-50 transition-colors cursor-pointer whitespace-nowrap"
        >
          Alle Tradingideen freischalten
          <FontAwesomeIcon icon={faArrowRight} className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}
